export default defineI18nConfig(() => ({
    lazy: false,
    locale: 'en',
    fallbackLocale: "en"
}));
